export default __webpack_public_path__ + "static/media/bauhaus-illustration.0767b817.svg";